<button
  *ngIf="profile.userDetail?.email && hasPrivilege(PrivilegeEnum.RESET_STUDENT_PASSWORDS)"
  mat-flat-button
  class="standard-button secondary-button"
  (click)="resetPassword()">
  Reset Password
</button>
